export default function selectBasedOnThemeID(themeID) {
    return (selection) => {
        return selection[themeID];
    };
}
